var map = {
	"./A_abroad.png": 7359,
	"./B_abroad.png": 1562,
	"./C_abroad.png": 9929,
	"./D_abroad.png": 8972,
	"./E_abroad.png": 2027,
	"./F_abroad.png": 3702,
	"./G_abroad.png": 9221,
	"./purpan_abroad.png": 1780
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2961;